import {ISSUES_TRACK_EVENT} from '../../utils/analytics-helpers';

export const setAnalyticsId = analyticsId => (dispatch, getState, {analyticsManager}) => {
  analyticsManager?.setAnalyticsId(analyticsId);
};

export const registerAnalyticsMandatorySuperProps = props => (dispatch, getState, {analyticsManager}) => {
  analyticsManager?.registerMandatorySuperProperties({...props});
};

export const setAnalyticsMandatoryPeopleProps = props => (dispatch, getState, {analyticsManager}) => {
  analyticsManager?.setMandatoryPeopleProperties({...props});
};

export const setAnalyticsPeopleProps = props => (dispatch, getState, {analyticsManager}) => {
  analyticsManager?.setPeopleProperties({...props});
};

export const trackEvent = event => (dispatch, getState, {analyticsManager}) => {
  analyticsManager?.track(event, ISSUES_TRACK_EVENT);
};
